var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        // 'c-table_scrolled': isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            {
              ref: "container",
              staticClass: "c-table__container",
              attrs: { id: "tableWithFixedFirstColumn" },
            },
            [
              _c(
                "thead",
                { ref: "header", staticClass: "c-table__header" },
                _vm._l(_vm.levels, function (i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "c-table__header-row" },
                    [
                      _vm._l(_vm.getTableColumns(i), function (column) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                              "c-table__column_highlight":
                                _vm.highlightColumns.includes(column.id),
                              "c-table__column_release_from_load":
                                column.id === "release_from_load",
                            },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan: _vm.getColspan(column),
                              rowspan: _vm.getRowspan(column),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.highlightColumnOnClick(column.id)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.label) + " ")]
                                ),
                                (column.description || column.type) &&
                                _vm.data.type !== "new-calculation-lateness"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-actions",
                                      },
                                      [
                                        column.fullName
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action c-table__column-action_description",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-description-${column.id}`,
                                                    size: "small",
                                                    icon: "info",
                                                    "no-border": "",
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-description-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.fullName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.isColumnFiltered(column.id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-filter-${column.id}`,
                                                    size: "small",
                                                    "no-border": "",
                                                    active:
                                                      _vm.isColumnActiveFiltered(
                                                        column.id
                                                      ),
                                                    icon: {
                                                      icon: "filter-column",
                                                      activeColor: "blue",
                                                    },
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openColumnFilterModal(
                                                        column
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-filter-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          )
                                                            ? "Изменить фильтр"
                                                            : "Применить фильтр"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.data.actions && i === 1
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "c-table__column c-table__column_actions",
                              attrs: { rowspan: _vm.levels },
                            },
                            [
                              _c("div", {
                                staticClass: "c-table__column-empty",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              _c(
                "tbody",
                { staticClass: "c-table__records" },
                [
                  _vm._l(_vm.data.records, function (group, recordIndex) {
                    return [
                      group.groupName !== "total"
                        ? _c("tr", { key: `table-record-${recordIndex}` }, [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "c-table__cell c-table__cell__grey c-table__cell__group__name c-table__cell__double__top__border",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-table__cell-value c-table__cell-value-groupname",
                                  },
                                  [
                                    _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Добавить сотрудников",
                                            placement: "bottom",
                                          },
                                          expression:
                                            "{\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: 'Добавить сотрудников',\n                    placement: 'bottom',\n                  }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "c-table__cell__button__add__post",
                                      attrs: {
                                        size: "iconic",
                                        icon: "plus",
                                        disabled: !_vm.canEdit,
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.canEdit &&
                                            _vm.$emit(
                                              "showModalAddWorkers",
                                              group
                                            )
                                        },
                                      },
                                    }),
                                    _vm._v(" " + _vm._s(group.groupName) + " "),
                                    !_vm.isFilialAdmin &&
                                    (_vm.isPostAdmin(group.code) ||
                                      _vm.isPostCook(group.code))
                                      ? _c("c-button-2", {
                                          staticClass:
                                            "c-table__groupname-action",
                                          attrs: {
                                            size: "iconic",
                                            icon: { icon: "money" },
                                            disabled: !_vm.canEdit,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.canEdit &&
                                                _vm.$emit(
                                                  "showPositionIntervalsModal",
                                                  group.code
                                                )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c("td", {
                              staticClass:
                                "c-table__cell c-table__cell__grey c-table__cell__double__top__border",
                              attrs: { colspan: "30" },
                            }),
                          ])
                        : _vm._e(),
                      _vm._l(group.records, function (record, recordIndex) {
                        return _c(
                          "tr",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: record.isShowRow,
                                expression: "record.isShowRow",
                              },
                            ],
                            key: `${group.code || group.groupName}-${
                              record.codeGroup || ""
                            }-${record.id}`,
                            staticClass: "c-table__record",
                            class: {
                              "c-table__record__highlight":
                                _vm.highlightRecords.includes(
                                  recordIndex + group.groupName
                                ),
                            },
                          },
                          [
                            _vm.data.type === "new-calculation-lateness"
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "c-table__cell_total c-table__cell c-table__cell_number",
                                    class: {
                                      "c-table__cell__grey": _vm.isGreyCell(
                                        _vm.data.type,
                                        "total",
                                        record.isTotalRow
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-table__cell-value" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(record["total"].value) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(
                              _vm.getTableColumns(_vm.levels),
                              function (column) {
                                return _c(
                                  "td",
                                  {
                                    key: column.id,
                                    staticClass: "c-table__cell",
                                    class: {
                                      "c-table__cell__yellow": _vm.isYellowCell(
                                        _vm.data.type,
                                        column.id,
                                        record[column.id]
                                          ? record[column.id].value
                                          : null,
                                        record.isTotalRow
                                      ),
                                      "c-table__cell__red":
                                        column.id === "depreciation" &&
                                        record[column.id] &&
                                        record[column.id].value > 0,
                                      "c-table__cell__green":
                                        column.id ===
                                          "premium_for_exceeding_standard" &&
                                        record[column.id] &&
                                        record[column.id].value > 0,
                                      "c-table__cell__grey":
                                        group.groupName === "total",
                                      "c-table__cell__blue":
                                        column.id === "total_accrued" ||
                                        column.id === "to_payoff" ||
                                        column.id === "already_paid",
                                      "c-table__cell__hide__borders":
                                        group.groupName === "total" &&
                                        (!record[column.id] ||
                                          record[column.id].value === null),
                                      "c-table__cell__double__top__border":
                                        group.groupName === "total",
                                      "c-table__cell_string":
                                        column.type === "string",
                                      "c-table__cell_reference":
                                        column.type === "reference",
                                      "c-table__cell_number":
                                        column.type === "number",
                                      "c-table__cell_date":
                                        column.type === "date",
                                      "c-table__cell_hidden": _vm.isDisabled(
                                        column.id
                                      ),
                                      "c-table__cell_highlight":
                                        _vm.highlightColumns.includes(
                                          column.id
                                        ),
                                      ["c-table__cell_" + column.id]: column.id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.highlightRowOnClick(
                                          recordIndex + group.groupName,
                                          column.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    column.id === "employee" &&
                                    group.groupName !== "total"
                                      ? _c("c-table-cell-employee", {
                                          attrs: {
                                            record: record,
                                            "can-edit": _vm.canEdit,
                                          },
                                          on: {
                                            productionRemoveWorkerFromCalc:
                                              _vm.productionRemoveWorkerFromCalc,
                                          },
                                        })
                                      : column.id === "release_from_load" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-release-from-load", {
                                          attrs: {
                                            record: record,
                                            "can-edit": _vm.canEdit,
                                          },
                                        })
                                      : column.id === "working_interval" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-intervals", {
                                          attrs: { record: record },
                                        })
                                      : column.id === "prize" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-prize", {
                                          attrs: {
                                            "calculation-data":
                                              _vm.calculationData,
                                            record: record,
                                            "calculate-type": _vm.calculateType,
                                            "can-edit": _vm.canEdit,
                                          },
                                          on: {
                                            updateBonuses: _vm.updateBonuses,
                                          },
                                        })
                                      : column.id ===
                                          "personal_account_transactions" &&
                                        group.groupName !== "total"
                                      ? _c(
                                          "c-table-cell-personal-account-transactions",
                                          {
                                            attrs: {
                                              "calculation-data":
                                                _vm.calculationData,
                                              "calculation-type":
                                                _vm.calculateType,
                                              record: record,
                                              "personal-reasons":
                                                _vm.personalReasons,
                                              "can-edit": _vm.canEdit,
                                            },
                                            on: {
                                              updateKPItable:
                                                _vm.updateKPItable,
                                              updatePersonal:
                                                _vm.updatePersonal,
                                            },
                                          }
                                        )
                                      : column.id === "fine" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-fine", {
                                          attrs: {
                                            "calculation-data":
                                              _vm.calculationData,
                                            record: record,
                                            "calculate-type": _vm.calculateType,
                                            "can-edit": _vm.canEdit,
                                          },
                                          on: { updateFines: _vm.updateFines },
                                        })
                                      : column.id === "rank" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-rank", {
                                          attrs: {
                                            "calculation-data":
                                              _vm.calculationData,
                                            record: record,
                                            "calculate-type": _vm.calculateType,
                                            "is-edit": true,
                                            "can-edit": _vm.canEdit,
                                          },
                                          on: { updateRank: _vm.updateRank },
                                        })
                                      : column.id === "compensation" &&
                                        group.groupName !== "total"
                                      ? _c("c-table-cell-compensation", {
                                          attrs: {
                                            "calculation-data":
                                              _vm.calculationData,
                                            record: record,
                                            "can-edit": _vm.canEdit,
                                          },
                                          on: {
                                            updateCompensation:
                                              _vm.updateCompensation,
                                          },
                                        })
                                      : column.id ===
                                          "premium_personal_account" &&
                                        group.groupName !== "total" &&
                                        _vm.calculateType === "byPeriod"
                                      ? _c(
                                          "c-table-cell-premium-personal-account",
                                          {
                                            attrs: {
                                              "calculation-data":
                                                _vm.calculationData,
                                              record: record,
                                              "can-edit": _vm.canEdit,
                                            },
                                          }
                                        )
                                      : column.id === "salary" ||
                                        column.id === "main_part_salary" ||
                                        column.id === "revenue_standard_hour" ||
                                        column.id === "revenue_standard" ||
                                        column.id === "total_accrued" ||
                                        column.id === "to_payoff" ||
                                        column.id === "already_paid" ||
                                        column.id ===
                                          "personal_account_accrued" ||
                                        column.id ===
                                          "personal_account_removed" ||
                                        column.id === "personal_account_balance"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.numberWithSpaces(
                                                    column.id,
                                                    record[column.id]
                                                      ? record[column.id].value
                                                      : null
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : column.id === "premium_personal_account"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  record
                                                    .personal_account_transactions
                                                    .value
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : column.id ===
                                        "premium_for_exceeding_standard"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__cell-value c-table__cell_custom",
                                            class: {
                                              "c-table__cell__green":
                                                !!_vm.getBonusValue(record),
                                              "c-table__cell__grey":
                                                group.groupName === "total",
                                            },
                                          },
                                          [
                                            _vm.premiumPersonalAccountLoading ||
                                            _vm.loadingItem.includes(record.id)
                                              ? _c("cell-loader", {
                                                  staticClass:
                                                    "new-calculation-loader",
                                                  attrs: {
                                                    active:
                                                      _vm.premiumPersonalAccountLoading ||
                                                      _vm.loadingItem.includes(
                                                        record.id
                                                      ),
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getBonusValue(record)
                                                    )
                                                  ),
                                                ]),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                            class: {
                                              "c-table__cell-value__grey":
                                                _vm.data.type ===
                                                  "new-calculation-lateness" &&
                                                _vm.isTotalValuesLateness(
                                                  column.id
                                                ),
                                              "c-table__cell-value__left__border":
                                                group.groupName === "total" &&
                                                record[column.id] &&
                                                record[column.id].value !==
                                                  null &&
                                                column.id !==
                                                  "deprivation_coefficient" &&
                                                column.id !==
                                                  "revenue_standard" &&
                                                column.id !==
                                                  "corrected_time" &&
                                                column.id !== "bonus_rate" &&
                                                column.id !==
                                                  "premium_for_exceeding_standard",
                                            },
                                            style: {
                                              "text-align":
                                                _vm.data.type ===
                                                  "new-calculation-lateness" &&
                                                column.id !==
                                                  "load_sushiChef" &&
                                                column.id !== "load_hotShop"
                                                  ? "center"
                                                  : "right",
                                            },
                                          },
                                          [
                                            column.id === "amount_working_time"
                                              ? [
                                                  record.confidence_level &&
                                                  record.confidence_level !==
                                                    "high"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            "c-table__cell-value__low-confidence":
                                                              record.confidence_level ===
                                                              "low",
                                                            "c-table__cell-value__medium-confidence":
                                                              record.confidence_level ===
                                                              "medium",
                                                          },
                                                          attrs: {
                                                            id: `confidence-tooltip-${recordIndex}-${group.groupName}`,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                !record[
                                                                  column.id
                                                                ] ||
                                                                  record[
                                                                    column.id
                                                                  ].value ==
                                                                    0 ||
                                                                  record[
                                                                    column.id
                                                                  ].value ===
                                                                    "00:00"
                                                                  ? ""
                                                                  : record[
                                                                      column.id
                                                                    ]
                                                                  ? record[
                                                                      column.id
                                                                    ].value
                                                                  : null
                                                              ) +
                                                              " "
                                                          ),
                                                          record.confidence_level ===
                                                          "low"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value__emoji",
                                                                },
                                                                [_vm._v("⚠️")]
                                                              )
                                                            : record.confidence_level ===
                                                              "medium"
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value__emoji",
                                                                },
                                                                [_vm._v("ℹ️")]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              !record[
                                                                column.id
                                                              ] ||
                                                                record[
                                                                  column.id
                                                                ].value == 0 ||
                                                                record[
                                                                  column.id
                                                                ].value ===
                                                                  "00:00"
                                                                ? ""
                                                                : record[
                                                                    column.id
                                                                  ]
                                                                ? record[
                                                                    column.id
                                                                  ].value
                                                                : null
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                  record.confidence_level &&
                                                  record.confidence_level !==
                                                    "high" &&
                                                  record.correction_type &&
                                                  record.correction_type !==
                                                    "none"
                                                    ? _c(
                                                        "b-popover",
                                                        {
                                                          attrs: {
                                                            target: `confidence-tooltip-${recordIndex}-${group.groupName}`,
                                                            triggers: "hover",
                                                            placement: "top",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.getCorrectionTypeMessage(
                                                                  record.correction_type
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        (column.id ===
                                                          "count_smenas" ||
                                                          column.id ===
                                                            "period_compensation" ||
                                                          column.id ===
                                                            "corrected_time" ||
                                                          column.id ===
                                                            "period_rank" ||
                                                          column.id ===
                                                            "premium_for_exceeding_standard" ||
                                                          column.id ===
                                                            "depreciation" ||
                                                          column.id ===
                                                            "compensation") &&
                                                          (!record[column.id] ||
                                                            record[column.id]
                                                              .value == 0 ||
                                                            record[column.id]
                                                              .value ===
                                                              "00:00")
                                                          ? ""
                                                          : record[column.id]
                                                          ? record[column.id]
                                                              .value
                                                          : null
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm.data.actions
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "c-table__cell c-table__cell_actions",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "c-table__cell-actions" },
                                      [
                                        _vm.data.type === "employees"
                                          ? _c("c-table-actions", {
                                              attrs: {
                                                type: _vm.data.type,
                                                record: record,
                                                "record-index": recordIndex,
                                                "record-count":
                                                  _vm.data.records.length,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(" " + _vm._s(_vm.emptyRecordsLabel) + " "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }